(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ks-filters"] && !Shopify.designMode) return;
  try {
    let ksCatalogueController;
let ksCompatibilityController;
let ksPriceTimer;

function ksCaptureCatalogueState(section) {
  const shell = section.querySelector('.ks-filter-shell');
  return {
    windowY: window.scrollY,
    shellScroll: shell ? shell.scrollTop : 0,
    details: Array.from(section.querySelectorAll('details'), (details) => details.open),
    optionScroll: Array.from(section.querySelectorAll('.ks-options,.ks-tag-options'), (options) => options.scrollTop)
  };
}

function ksRestoreCatalogueState(section, state) {
  section.querySelectorAll('details').forEach((details, index) => {
    if (typeof state.details[index] === 'boolean') details.open = state.details[index];
  });
  const shell = section.querySelector('.ks-filter-shell');
  if (shell) shell.scrollTop = state.shellScroll;
  section.querySelectorAll('.ks-options,.ks-tag-options').forEach((options, index) => {
    options.scrollTop = state.optionScroll[index] || 0;
  });
  requestAnimationFrame(() => window.scrollTo(0, state.windowY));
}

function ksAvailabilityData(html) {
  if (!html) return null;
  const documentFragment = new DOMParser().parseFromString(html, 'text/html');
  const wrapper = documentFragment.body.firstElementChild;
  if (!wrapper) return null;
  try {
    return JSON.parse(wrapper.textContent.trim());
  } catch {
    return null;
  }
}

async function ksCollectAvailableTags(targetUrl, firstHtml, signal) {
  let firstData = ksAvailabilityData(firstHtml);
  if (!firstData) {
    const firstUrl = new URL(targetUrl);
    firstUrl.searchParams.delete('sections');
    firstUrl.searchParams.set('section_id', 'ks-filter-availability');
    firstUrl.searchParams.set('page', '1');
    const firstResponse = await fetch(firstUrl, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!firstResponse.ok) return null;
    firstData = ksAvailabilityData(await firstResponse.text());
  }
  if (!firstData) return null;
  const tags = new Set(firstData.tags || []);
  const pages = Number(firstData.pages) || 1;
  const currentPage = Number(firstData.page) || 1;
  const pageNumbers = [];
  for (let page = 1; page <= pages; page += 1) {
    if (page !== currentPage) pageNumbers.push(page);
  }
  for (let index = 0; index < pageNumbers.length; index += 4) {
    const batch = pageNumbers.slice(index, index + 4);
    const pageData = await Promise.all(batch.map(async (page) => {
      const pageUrl = new URL(targetUrl);
      pageUrl.searchParams.delete('sections');
      pageUrl.searchParams.set('section_id', 'ks-filter-availability');
      pageUrl.searchParams.set('page', String(page));
      const response = await fetch(pageUrl, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) return null;
      return ksAvailabilityData(await response.text());
    }));
    pageData.forEach((data) => {
      if (data && Array.isArray(data.tags)) data.tags.forEach((tag) => tags.add(tag));
    });
  }
  return tags;
}

function ksApplyAvailableTags(section, availableTags) {
  if (!availableTags) return;
  section.querySelectorAll('.ks-tag-option[data-filter-tag]').forEach((option) => {
    const selected = option.classList.contains('is-selected');
    const available = selected || availableTags.has(option.dataset.filterTag);
    const link = option.querySelector('a');
    option.classList.toggle('is-unavailable', !available);
    if (!link) return;
    if (available) {
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
    } else {
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
    }
  });
}

async function ksRefreshCustomAvailability(section, targetUrl, firstHtml) {
  const shell = section.querySelector('.ks-filter-shell');
  if (!shell || shell.dataset.hasActiveFilters !== 'true' || !section.querySelector('.ks-tag-option[data-filter-tag]')) return;
  if (ksCompatibilityController) ksCompatibilityController.abort();
  ksCompatibilityController = new AbortController();
  try {
    const tags = await ksCollectAvailableTags(targetUrl, firstHtml, ksCompatibilityController.signal);
    if (!ksCompatibilityController.signal.aborted) ksApplyAvailableTags(section, tags);
  } catch (error) {
    if (error.name !== 'AbortError') console.error(error);
  }
}

function ksFormUrl(form) {
  const target = new URL(form.action, location.href);
  const current = new URL(location.href);
  target.search = '';
  const formNames = new Set();
  for (const [name, value] of current.searchParams) {
    if (name === 'page' || name === 'sections' || name === 'section_id' || name.startsWith('filter.')) continue;
    target.searchParams.append(name, value);
  }
  for (const [name, value] of new FormData(form)) {
    if (value !== '') {
      if (!formNames.has(name)) target.searchParams.delete(name);
      target.searchParams.append(name, value);
      formNames.add(name);
    }
  }
  target.searchParams.delete('page');
  return target;
}

function ksTagUrl(link) {
  const target = new URL(link.href, location.href);
  const form = link.closest('.ks-catalogue').querySelector('.ks-filters');
  for (const name of Array.from(target.searchParams.keys())) {
    if (name === 'page' || name.startsWith('filter.')) target.searchParams.delete(name);
  }
  if (form) {
    for (const [name, value] of new FormData(form)) {
      if (value !== '' && (name.startsWith('filter.') || name === 'q' || name === 'type')) target.searchParams.append(name, value);
    }
  }
  const current = new URL(location.href);
  for (const [name, value] of current.searchParams) {
    if (name === 'page' || name === 'sections' || name === 'section_id' || name.startsWith('filter.') || target.searchParams.has(name)) continue;
    target.searchParams.append(name, value);
  }
  target.searchParams.delete('page');
  return target;
}

async function ksNavigateCatalogue(inputUrl, historyMode) {
  const currentCatalogue = document.querySelector('.ks-catalogue');
  const currentSection = currentCatalogue ? currentCatalogue.closest('.shopify-section') : null;
  if (!currentCatalogue || !currentSection || !currentSection.id) {
    location.assign(inputUrl);
    return;
  }
  const targetUrl = new URL(inputUrl, location.href);
  targetUrl.searchParams.delete('sections');
  targetUrl.searchParams.delete('section_id');
  const state = ksCaptureCatalogueState(currentSection);
  if (ksCatalogueController) ksCatalogueController.abort();
  if (ksCompatibilityController) ksCompatibilityController.abort();
  ksCatalogueController = new AbortController();
  currentCatalogue.classList.add('is-loading');
  currentCatalogue.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(targetUrl, {
      signal: ksCatalogueController.signal,
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Catalogue update failed');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextCatalogue = parsed.querySelector('.ks-catalogue');
    const replacement = nextCatalogue ? nextCatalogue.closest('.shopify-section') : null;
    if (!replacement) throw new Error('Catalogue section could not be parsed');
    const swap = () => currentSection.replaceWith(replacement);
    if (document.startViewTransition) {
      const transition = document.startViewTransition(swap);
      await transition.updateCallbackDone;
    } else {
      swap();
    }
    if (historyMode === 'replace') history.replaceState({}, '', targetUrl);
    else if (historyMode !== 'none') history.pushState({}, '', targetUrl);
    if (parsed.title) document.title = parsed.title;
    ksFiltersInit();
    if (typeof ksCatalogueInit === 'function') ksCatalogueInit();
    if (typeof ksTagFiltersInit === 'function') ksTagFiltersInit();
    ksRestoreCatalogueState(replacement, state);
    await ksRefreshCustomAvailability(replacement, targetUrl);
  } catch (error) {
    if (error.name === 'AbortError') return;
    location.assign(targetUrl);
  }
}

function ksFiltersInit() {
  document.querySelectorAll('.ks-filter-shell').forEach((shell) => {
    if (shell.dataset.ready) return;
    shell.dataset.ready = '1';
    const refine = shell.querySelector('.ks-refine');
    if (window.matchMedia('(max-width:700px)').matches && refine && !history.state) refine.open = false;
    shell.querySelectorAll('.ks-facet-search').forEach((input) => {
      input.addEventListener('input', () => {
        const term = input.value.toLowerCase().trim();
        input.closest('.ks-facet').querySelectorAll('.ks-option').forEach((option) => {
          option.hidden = !option.textContent.toLowerCase().includes(term);
        });
      });
    });
  });
  if (document.documentElement.dataset.ksAjaxFiltersReady) return;
  document.documentElement.dataset.ksAjaxFiltersReady = 'true';

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.ks-filters,#ks-sort-form')) return;
    event.preventDefault();
    const min = form.querySelector('[data-price-min]');
    const max = form.querySelector('[data-price-max]');
    const error = form.querySelector('[data-price-error]');
    if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
      if (error) error.hidden = false;
      max.focus();
      return;
    }
    if (error) error.hidden = true;
    ksNavigateCatalogue(ksFormUrl(form), 'push');
  });

  document.addEventListener('change', (event) => {
    const filterForm = event.target.closest('.ks-filters');
    if (filterForm && event.target.matches('input[type="checkbox"],input[type="radio"],select')) {
      filterForm.requestSubmit();
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-price-min],[data-price-max]')) return;
    clearTimeout(ksPriceTimer);
    const form = event.target.closest('.ks-filters');
    ksPriceTimer = setTimeout(() => form.requestSubmit(), 650);
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.ks-tag-option a,.ks-selected-chip a,.ks-filter-actions a,.ks-active a,.ks-pagination a');
    if (!link || !link.closest('.ks-catalogue') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    const isTagLink = Boolean(link.closest('.ks-tag-option,.ks-selected-chip--tag'));
    ksNavigateCatalogue(isTagLink ? ksTagUrl(link) : link.href, 'push');
  });

  window.addEventListener('popstate', () => ksNavigateCatalogue(location.href, 'none'));
}

ksFiltersInit();
const initialCatalogue = document.querySelector('.ks-catalogue');
if (initialCatalogue) ksRefreshCustomAvailability(initialCatalogue.closest('.shopify-section') || initialCatalogue, location.href);
document.addEventListener('shopify:section:load', ksFiltersInit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-live-search"] && !Shopify.designMode) return;
  try {
    (()=>{const box=document.querySelector('#ks-search-results');if(!box)return;const form=box.closest('form'),input=form.querySelector('[name="q"]');let timer,controller,revision=0;input.setAttribute('aria-controls',box.id);input.setAttribute('aria-expanded','false');input.autocomplete='off';const close=()=>{box.hidden=true;input.setAttribute('aria-expanded','false');};const safeURL=value=>{const u=new URL(value,location.origin);return ['http:','https:'].includes(u.protocol)?u.href:null;};input.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();const ticket=++revision,q=input.value.trim();close();if(q.length<2)return;timer=setTimeout(async()=>{controller=new AbortController();try{const url=new URL(box.dataset.suggestUrl,location.origin);url.search=new URLSearchParams({q,'resources[type]':'product','resources[limit]':'6','resources[options][fields]':'title,variants.title,variants.sku'});const res=await fetch(url,{signal:controller.signal});if(!res.ok)throw Error();const data=await res.json();if(ticket!==revision)return;box.replaceChildren();for(const p of data.resources?.results?.products||[]){const href=safeURL(p.url);if(!href)continue;const a=document.createElement('a');a.href=href;if(p.image){const src=safeURL(typeof p.image==='string'?p.image:p.image.url);if(src){const image=document.createElement('img');image.src=src;image.alt='';image.width=48;image.height=48;a.append(image);}}const title=document.createElement('span');title.textContent=p.title;a.append(title);box.append(a);}if(!box.children.length){const p=document.createElement('p');p.textContent=box.dataset.empty;box.append(p);}const all=document.createElement('a'),target=new URL(form.action);target.search=new URLSearchParams({q,type:'product','options[prefix]':'last'});all.href=target.href;all.textContent=box.dataset.all;box.append(all);box.hidden=false;input.setAttribute('aria-expanded','true');}catch(e){if(e.name==='AbortError'||ticket!==revision)return;const p=document.createElement('p');p.textContent=box.dataset.failure;box.replaceChildren(p);box.hidden=false;input.setAttribute('aria-expanded','true');}},220);});form.addEventListener('keydown',e=>{if(e.key==='Escape'){revision++;controller?.abort();close();input.focus();}if(['ArrowDown','ArrowUp'].includes(e.key)&&!box.hidden){const links=[...box.querySelectorAll('a')];if(!links.length)return;e.preventDefault();const index=links.indexOf(document.activeElement);links[(index+(e.key==='ArrowDown'?1:-1)+links.length)%links.length].focus();}});document.addEventListener('click',e=>{if(!form.contains(e.target))close();});form.addEventListener('focusout',()=>setTimeout(()=>{if(!form.contains(document.activeElement))close();},0));})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-spec-tag-group"] && !Shopify.designMode) return;
  try {
    function ksTagFiltersInit(){document.querySelectorAll('.ks-tag-search').forEach(input=>{if(input.dataset.ready)return;input.dataset.ready='1';input.addEventListener('input',()=>{const term=input.value.toLowerCase().trim();input.closest('.ks-spec-facet').querySelectorAll('.ks-tag-option').forEach(option=>option.hidden=!option.dataset.filterValue.includes(term));});});}ksTagFiltersInit();document.addEventListener('shopify:section:load',ksTagFiltersInit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-storefront-copy"] && !Shopify.designMode) return;
  try {
    (()=>{
 const clean=container=>{
  if(!(container instanceof Element))return;
  const walker=document.createTreeWalker(container,NodeFilter.SHOW_TEXT,{acceptNode:node=>node.parentElement.closest('script,style,textarea,input,code')?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT});
  let node;
  while((node=walker.nextNode())){
   const next=node.nodeValue.replace(/, including Shopify,/g,'').replace(/including Shopify/g,'including our online-store provider');
   if(next!==node.nodeValue)node.nodeValue=next;
  }
 };
 const refresh=()=>document.querySelectorAll('[id*="consent"],[id*="privacy"],[role="alertdialog"]').forEach(clean);
 let scheduled=false;
 new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;refresh();});}).observe(document.body,{childList:true,subtree:true,characterData:true});
 refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-warranty-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ks-warranty'))customElements.define('ks-warranty',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.plans=JSON.parse(this.querySelector('[data-warranty-variants]').textContent).sort((a,b)=>a.cap-b.cap);
  this.labels=JSON.parse(this.querySelector('[data-warranty-labels]').textContent);
  this.select=this.querySelector('[data-cover]');this.message=this.querySelector('[data-warranty-message]');
  this.money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'});
  this.select.addEventListener('change',()=>this.dispatchEvent(new CustomEvent('warrantychange',{bubbles:true})));
  if(this.dataset.mode==='product'){
   this.form=this.closest('form');this.servers=JSON.parse(this.querySelector('[data-server-variants]').textContent);
   this.serverTitle=JSON.parse(this.querySelector('[data-server-title]').textContent);
   const update=()=>{this.server=this.servers.find(v=>String(v.id)===String(this.form.elements.id.value));this.setValue(this.server?.price,this.server?.available);};
   this.form.elements.id.addEventListener('change',update);update();
   this.form.addEventListener('submit',async e=>{
    const plan=this.selected();if(!plan)return;e.preventDefault();if(this.busy||!this.form.reportValidity())return;
    const quantity=Number(this.form.elements.quantity.value);if(!Number.isInteger(quantity)||quantity<1)return;
    this.busy=true;const button=this.form.querySelector('[data-add]');button.disabled=true;this.message.textContent='';
    const group=crypto.randomUUID();const properties=Object.fromEntries([...new FormData(this.form)].filter(([k])=>/^properties\[.+\]$/.test(k)).map(([k,v])=>[k.slice(11,-1),v]));
    try{
     const res=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:this.server.id,quantity,properties:{...properties,_ks_warranty_group:group}},{id:plan.id,quantity,properties:{_ks_warranty_group:group,Server:this.serverTitle,SKU:this.server.sku||String(this.server.id),'Hardware value':this.money.format(this.server.price/100),'Cover from delivery':plan.years+' year'+(plan.years===1?'':'s')}}]})});
     if(!res.ok)throw Error();location.assign(this.dataset.cart);
    }catch{this.message.textContent=this.labels.failure;button.disabled=!this.server.available;this.busy=false;}
   });
  }else this.setValue(null,false);
 }
 setValue(cents,known=true){
  this.value=cents;this.known=known&&Number.isFinite(cents)&&cents>0&&this.dataset.currency==='GBP';
  for(const option of [...this.select.options].slice(1)){
   const years=Number(option.value),plan=this.known?this.plans.find(p=>p.years===years&&p.cap>=cents&&p.available):null;
   option.disabled=!plan;option.textContent=years+' '+(years===1?'year':'years')+' '+this.labels.total+(plan?' — +'+this.money.format(plan.price/100)+' '+this.labels.each:'');
  }
  if(this.select.selectedOptions[0]?.disabled)this.select.value='0';
  this.message.textContent=!this.known?this.labels.pending:this.select.options[1].disabled?this.labels.unavailable:'';
 }
 selected(){const years=Number(this.select.value);return years&&this.known?this.plans.find(p=>p.years===years&&p.cap>=this.value&&p.available)||null:null;}
});
  } catch(e) { console.error(e); }
})();

})();
